import React from 'react';
import { useAuth } from '../context/AuthContext';
import './MaskedPhone.css';

// Pull the first two local digits out of a Cyprus number ("+357 99 …" → "99").
// Falls back to "99" (generic mobile prefix) when the input is missing or
// doesn't match the expected shape.
function firstTwoLocalDigits(phone) {
  if (!phone) return '99';
  let digits = String(phone).replace(/\D/g, '');
  if (digits.startsWith('00357')) digits = digits.slice(5);
  else if (digits.startsWith('357')) digits = digits.slice(3);
  const head = digits.slice(0, 2);
  return /^\d{2}$/.test(head) ? head : '99';
}

export default function MaskedPhone({ phone, icon = null, className = '' }) {
  const { user } = useAuth();

  if (user) {
    if (!phone) return null;
    return (
      <a href={`tel:${phone}`} className={className}>
        {icon}{icon ? ' ' : null}{phone}
      </a>
    );
  }

  // Logged out: icon + "+357 NN" stay sharp; the remaining digits are clean
  // bullet placeholders styled to match the rest. No blur, no CTA.
  const head = firstTwoLocalDigits(phone);
  return (
    <span className={`masked-phone ${className}`}>
      {icon}
      <span className="masked-phone__sharp">
        {icon ? ' ' : null}+357 {head}
      </span>
      <span className="masked-phone__dots" aria-hidden="true"> ••• •••</span>
    </span>
  );
}
